/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import CTypeTab from '@/components/CTypeTab.vue';
import DateHeaderWithBtn from '@/views/Feeding/cpns/DateHeaderWithBtn.vue';
import { useEmptyStringFormat } from '@/hooks/fn';
import { PieEchart, LineEchart } from '@/components/page-echarts';
import CNoData from '@/components/CNoData.vue';
import RankListItem from './RankListItem.vue';
import { getTimeRange } from '@/views/Feeding/hooks/time';
import { useSaleTotal, useSaleRtoVolume, useSaleRtoAmount, useSaleHourRevenue, useSaleDayRevenue, useSalePayRto, useSaleRank } from '../hooks/useSaleForm';
export default defineComponent({
  name: 'ReportForm',
  components: {
    CTypeTab: CTypeTab,
    PieEchart: PieEchart,
    LineEchart: LineEchart,
    CNoData: CNoData,
    RankListItem: RankListItem,
    DateHeaderWithBtn: DateHeaderWithBtn
  },
  setup: function setup() {
    //当前日期区间
    var params = ref({
      startTime: "".concat(dayjs().format('YYYY-MM-DD'), " 00:00:00"),
      endTime: "".concat(dayjs().format('YYYY-MM-DD'), " 23:59:59"),
      type: 0
    });
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        var date, timeData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              date = '';
              if (val === 3) {
                date = "".concat(dayjs().format('YYYY/MM/DD'), " 00:00:00,").concat(dayjs().format('YYYY/MM/DD HH:mm:ss'));
              } else {
                date = dayjs().format('YYYY/MM/DD');
              }
              timeData = getTimeRange(params.value.type, date);
              params.value.startTime = timeData.startTime;
              params.value.endTime = timeData.endTime;
              getSaleTotalAsync();
              initSaleRto();
              initRevenueAsyne();
              getSalePayRtoAsync();
              getSaleRankAsync();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var emptyStringFormat = useEmptyStringFormat();
    var confrimDate = function confrimDate(val) {
      var timeData = getTimeRange(params.value.type, val);
      params.value.startTime = timeData.startTime;
      params.value.endTime = timeData.endTime;
      getSaleTotalAsync();
      initSaleRto();
      initRevenueAsyne();
      getSalePayRtoAsync();
      getSaleRankAsync();
    };
    var _useSaleTotal = useSaleTotal(params),
      _useSaleTotal2 = _slicedToArray(_useSaleTotal, 2),
      saleTotalList = _useSaleTotal2[0],
      getSaleTotalAsync = _useSaleTotal2[1];
    var summaryData = computed(function () {
      return saleTotalList.value;
    });
    var tabs = ref(['销量', '金额']);
    var curTab = ref('销量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var _useSaleRtoVolume = useSaleRtoVolume(params),
      _useSaleRtoVolume2 = _slicedToArray(_useSaleRtoVolume, 2),
      saleRtoVolume = _useSaleRtoVolume2[0],
      getSaleRtoVolumeAsync = _useSaleRtoVolume2[1];
    var _useSaleRtoAmount = useSaleRtoAmount(params),
      _useSaleRtoAmount2 = _slicedToArray(_useSaleRtoAmount, 2),
      saleRtoAmount = _useSaleRtoAmount2[0],
      getSaleRtoAmountAsync = _useSaleRtoAmount2[1];
    var initSaleRto = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getSaleRtoVolumeAsync();
              getSaleRtoAmountAsync();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function initSaleRto() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 销售占比
    var categorySaleCount = computed(function () {
      var list = [];
      var unit = '';
      if (curTab.value === '销量') {
        list = saleRtoVolume.value.map(function (item) {
          return {
            name: item.name,
            value: +item.value.split('吨')[0],
            percent: item.ratio_num
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '吨';
      }
      if (curTab.value === '金额') {
        list = saleRtoAmount.value.map(function (item) {
          return {
            name: item.name,
            value: +item.value.split('万元')[0],
            percent: item.ratio_num
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '万元';
      }
      return {
        pieData: list,
        unit: unit,
        customTooltip: true,
        labelShow: true,
        customLabel: true,
        fontSize: 12,
        labelFormatter: function labelFormatter(params) {
          var res = "".concat(params.percent, "%\n").concat(params.value).concat(unit, "\n").concat(params.name);
          return res;
        },
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '销量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.percent, "%</span>\n                      </div>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u5428</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '金额') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.percent, "%</span>\n                      </div>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u4E07\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    // 计算时间是否大于一天
    var outweighOneDay = computed(function () {
      var start = new Date(params.value.startTime).getTime();
      var end = new Date(params.value.endTime).getTime();
      var diff = Math.abs(end - start); // 绝对值，确保正数
      var oneDayMs = 24 * 60 * 60 * 1000;
      // 超过一天返回true，一天之内（含等于）返回false
      return diff > oneDayMs;
    });
    var _useSaleHourRevenue = useSaleHourRevenue(params),
      _useSaleHourRevenue2 = _slicedToArray(_useSaleHourRevenue, 2),
      saleHourRevenue = _useSaleHourRevenue2[0],
      getSaleHourRevenueAsync = _useSaleHourRevenue2[1];
    var _useSaleDayRevenue = useSaleDayRevenue(params),
      _useSaleDayRevenue2 = _slicedToArray(_useSaleDayRevenue, 2),
      saleDayRevenue = _useSaleDayRevenue2[0],
      getSaleDayRevenueAsync = _useSaleDayRevenue2[1];
    var trendData = ref([]);
    var initRevenueAsyne = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!outweighOneDay.value) {
                _context3.next = 6;
                break;
              }
              _context3.next = 3;
              return getSaleDayRevenueAsync();
            case 3:
              trendData.value = saleDayRevenue.value;
              _context3.next = 9;
              break;
            case 6:
              _context3.next = 8;
              return getSaleHourRevenueAsync();
            case 8:
              trendData.value = saleHourRevenue.value;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function initRevenueAsyne() {
        return _ref3.apply(this, arguments);
      };
    }();
    var curTabS = ref('销量');
    var tabClickS = function tabClickS(val) {
      curTabS.value = val;
    };
    // 营收趋势
    var revenueCount = computed(function () {
      var list = [];
      var xLabels = [];
      if (curTabS.value === '销量') {
        list = trendData.value.map(function (item) {
          return +item.volume_value.split('吨')[0];
        });
        xLabels = trendData.value.map(function (item) {
          return item.name;
        });
      }
      if (curTabS.value === '金额') {
        list = trendData.value.map(function (item) {
          return +item.value.split('万元')[0];
        });
        xLabels = trendData.value.map(function (item) {
          return item.name;
        });
      }
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: [],
        yName: '',
        height: '200px',
        showDetail: true,
        formatter: function formatter(params) {
          var res = "\n              <div >\n              ";
          if (curTabS.value === '销量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mr-1\">\u9500\u91CF</span>\n                    <span style=\"font-size: 12px;\">".concat(params[0].value, "\u5428</span>\n                  </div>\n                ");
          }
          if (curTabS.value === '金额') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mr-1\">\u8425\u6536</span>\n                    <span style=\"font-size: 12px;\">".concat(params[0].value, "\u4E07\u5143</span>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    var _useSalePayRto = useSalePayRto(params),
      _useSalePayRto2 = _slicedToArray(_useSalePayRto, 2),
      salePayRto = _useSalePayRto2[0],
      getSalePayRtoAsync = _useSalePayRto2[1];
    // 支付方式占比
    var payRtoPie = computed(function () {
      var list = [];
      list = salePayRto.value.map(function (item) {
        return {
          name: item.name,
          value: +item.value.split('万元')[0],
          percent: item.ratio_num
        };
      }).filter(function (item) {
        return item.value;
      });
      return {
        pieData: list,
        fontSize: 12,
        customLabel: true,
        labelFormatter: function labelFormatter(params) {
          var res = "".concat(params.percent, "%\n").concat(params.value, "\u4E07\u5143\n").concat(params.name);
          return res;
        },
        labelShow: true,
        unit: '万元',
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          return "\n            <div >\n              <div class=\"flex align-start\">\n                <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                <div>\n                  <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                  <div>\n                    <span style=\"font-size: 12px;\">").concat(params.percent, "%</span>\n                  </div>\n                  <div>\n                  <span style=\"font-size: 12px;\">").concat(params.value, "\u4E07\u5143</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            ");
        }
      };
    });
    var _useSaleRank = useSaleRank(params),
      _useSaleRank2 = _slicedToArray(_useSaleRank, 2),
      saleRank = _useSaleRank2[0],
      getSaleRankAsync = _useSaleRank2[1];
    onMounted(function () {
      getSaleTotalAsync();
      initSaleRto();
      initRevenueAsyne();
      getSalePayRtoAsync();
      getSaleRankAsync();
    });
    var router = useRouter();
    var toSaleFormProp = function toSaleFormProp() {
      router.push({
        name: 'SaleFormProp',
        params: {
          startTime: params.value.startTime,
          endTime: params.value.endTime,
          type: params.value.type //日周月
        }
      });
    };
    return {
      dateRef: dateRef,
      confirmType: confirmType,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      curTabS: curTabS,
      tabClickS: tabClickS,
      categorySaleCount: categorySaleCount,
      revenueCount: revenueCount,
      payRtoPie: payRtoPie,
      confrimDate: confrimDate,
      emptyStringFormat: emptyStringFormat,
      params: params,
      summaryData: summaryData,
      saleRank: saleRank,
      toSaleFormProp: toSaleFormProp,
      outweighOneDay: outweighOneDay
    };
  }
});